export default {
  title: 'Finalizare comandă',
};
